<template>
    <div class="charpter2">
      <CharpterTwo></CharpterTwo>
    </div>
    
  
</template>
<script>

import CharpterTwo from "@/components/CharpterTwo.vue";

export default {
    name:"Charpter2",
    components:{
       CharpterTwo
    }
}
</script>
<style lang="scss" scoped>

</style>